// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductDisplayPage_wrapper__Z7xY4"};